/* ++++++++++ --------------- EXPORT : HUBSPOT MODAL : STYLES --------------- ++++++++++ */
export default theme => ({
    hubspotmodal: {
        width: '75vw',
        height: '90vh',
        overflowY: 'scroll',
        overflowX: 'hidden',
        '& iframe': {
            width: '100% !important'
        }
    }
});
